import plugin from '@serializedowen/vue-img-watermark'
import Vue from 'vue'

Vue.use(plugin)

export default plugin